<template>
  <section id="all-billing-listing" class="all-cases-view">
    <div class="container-default">
      <div class="listings-navbar">
        <el-row>
          <el-col :lg="12">
            <ul class="d-flex list-items-group-15">
              <li v-if="hasPermission('cases', 'create')">
                <el-button
                  class="btn button-with-icon"
                  @click="addNewBillingCase"
                >
                  <span class="mr-8">
                    <img
                      src="@/assets/images/icons/plus-icon.svg"
                      alt="icon"
                      class="inactive"
                    />
                    <img
                      src="@/assets/images/icons/plus-icon-white.svg"
                      alt="icon"
                      class="active"
                    />
                  </span>
                  <span> ADD BILLING CASES </span>
                </el-button>
              </li>
              <li v-if="hasPermission('cases', 'create')">
                <el-button
                  class="btn button-with-icon"
                  @click="billingCasesExport"
                >
                  <span class="mr-8">
                    <img
                      src="@/assets/images/icons/export-icon-with-bg-blue.svg"
                      alt="icon"
                      class="inactive"
                    />
                    <img
                      src="@/assets/images/icons/export-icon-white.svg"
                      alt="icon"
                      class="active"
                    />
                  </span>
                  <span>EXPORT</span>
                </el-button>
              </li>
              <li>
                <div class="form-element input-with-icon search-input-lg">
                  <el-input
                    placeholder="Accession / Patient Name"
                    v-model="search_string"
                    @input="getAutoCompleteBillings()"
                    :clearable="true"
                    suffix-icon="el-icon-date"
                  ></el-input>
                  <span>
                    <img
                      src="@/assets/images/icons/search-icon-with-bg-red.svg"
                      alt="icon"
                      class="img-fluid icon"
                    />
                  </span>
                </div>
              </li>
            </ul>
          </el-col>
          <el-col :lg="12">
            <ul
              class="d-flex flex-wrap justify-content-end list-items-group-15"
            >
              <li>
                <div class="form-element search-with-filter-input-without-icon">
                  <el-select
                    v-model="searchBy"
                    clearable
                    filterable
                    default-first-option
                    :reserve-keyword="false"
                    placeholder="Select Search"
                    @change="clearInputSearch"
                  >
                    <el-option
                      v-for="item in searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </li>

              <li v-if="searchBy == 'Patient DOB'">
                <div class="search-with-date-input">
                  <el-date-picker
                    format="MM-DD-YYYY"
                    v-model="date_of_birth"
                    :disabled-date="disabledDate"
                    @change="fetchAllBillings()"
                    placeholder="Select DOB"
                    :clearable="true"
                  ></el-date-picker>
                </div>
              </li>
              <li v-else-if="searchBy == 'hospital'">
                <div class="form-element search-with-filter-input">
                  <el-select
                    v-model="hospital"
                    placeholder="Select Ordering Facility"
                    filterable
                    clearable
                    default-first-option
                    @change="handleCurrentChange(1)"
                    @focus="fetchAllHospitals"
                    :loading="hospitalsLoading"
                  >
                    <el-option
                      v-for="hospital in hospitalsData.data"
                      :key="hospital"
                      :label="hospital.name"
                      :value="hospital._id"
                    >
                    </el-option>
                  </el-select>
                  <span class="search-icon">
                    <img
                      src="@/assets/images/icons/search-icon-with-bg-red.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                </div>
              </li>
              <li v-else-if="searchBy == 'ordering_physician'">
                <div class="form-element search-with-filter-input">
                  <el-select
                    v-model="physician"
                    placeholder="Select"
                    filterable
                    clearable
                    default-first-option
                    @change="handleCurrentChange(1)"
                    @focus="fetchAllPhysicians"
                    :loading="physiciansLoading"
                  >
                    <el-option
                      v-for="physician in physiciansData.data"
                      :key="physician"
                      :label="physician.name"
                      :value="physician._id"
                    >
                    </el-option>
                  </el-select>
                  <span class="search-icon">
                    <img
                      src="@/assets/images/icons/search-icon-with-bg-red.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                </div>
              </li>
              <li v-else-if="searchBy == 'case_types'">
                <div
                  class="form-element search-with-filter-input"
                  v-if="
                    getAuthenticatedUser.user_type == 'LAB_TECHNOLOGIST' &&
                    getAuthenticatedUser.allowed_case_types
                  "
                >
                  <el-select
                    v-model="caseType"
                    placeholder="Select"
                    filterable
                    clearable
                    default-first-option
                    :reserve-keyword="false"
                    @change="handleCurrentChange(1)"
                  >
                    <el-option
                      v-for="caseType in getUserBasedCaseTypes(caseTypes)"
                      :key="caseType"
                      :label="caseType.label"
                      :value="caseType.value"
                    >
                    </el-option>
                  </el-select>
                  <span class="search-icon">
                    <img
                      src="@/assets/images/icons/search-icon-with-bg-red.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                </div>
                <div class="form-element search-with-filter-input" v-else>
                  <el-select
                    v-model="caseType"
                    placeholder="Select"
                    filterable
                    clearable
                    default-first-option
                    :reserve-keyword="false"
                    @change="handleCurrentChange(1)"
                  >
                    <el-option
                      v-for="caseType in getLabBasedCaseTypes(caseTypes)"
                      :key="caseType"
                      :label="caseType.label"
                      :value="caseType.value"
                    >
                    </el-option>
                  </el-select>
                  <span class="search-icon">
                    <img
                      src="@/assets/images/icons/search-icon-with-bg-red.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>

      <div class="primary-content-view-new" v-loading="loading">
        <div class="listings listings__table listings__all-cases">
          <el-table
            :data="getAllBillingCases.data"
            @sort-change="onChangeSort"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
          >
            <el-table-column
              prop="accession_id"
              label="Accession ID"
              min-width="150"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <div class="name-accession">
                  <span id="accession-id" @click="goToCaseView(scope.row._id)">
                    {{ scope.row.accession_id }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="patient_info.first_name"
              label="PATIENT NAME"
              min-width="200"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <div class="name-accession">
                  <span id="patient-name">
                    {{ convertToUppercase(getPatientNameByInfo(scope.row.patient_info)) }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Patient DOB" min-width="150">
              <template #default="scope">
                {{ formatDate(scope.row.patient_info.date_of_birth) }}
              </template>
            </el-table-column>

            <el-table-column
              label="Case Type"
              min-width="170"
              prop="case_types"
              sortable="custom"
            >
              <template #default="scope">
                <div
                  class="case-type"
                  v-if="scope.row.case_types && scope.row.case_types.length > 1"
                >
                  <el-dropdown>
                    <span class="case-data-type">
                      {{ getCaseTypes(scope.row.case_types)[0] }}

                      <img
                        src="@/assets/images/case-type-arrow.svg"
                        alt="icon"
                      />
                    </span>

                    <template #dropdown>
                      <el-dropdown-menu class="case-type-dropdown">
                        <el-dropdown-item
                          class="cases-view"
                          v-for="(caseType, index) of getCaseTypes(
                            scope.row.case_types
                          )"
                          :key="index"
                        >
                          {{ caseType }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
                <div v-else class="case-type">
                  <span class="case-data-type">
                    {{ getCaseTypes(scope.row.case_types)[0] }}
                  </span>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="hospitals"
              label="ORDERING FACILITIES"
              min-width="250"
            >
              <template #default="scope">
                <span class="table_cell-ellipsis" v-if="scope.row.hospital">{{
                  scope.row.hospital.name
                }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="physician" label="PHYSICIAN" min-width="200">
              <template #default="scope">
                <span
                  class="text-center ordering_facility-value"
                  v-if="scope.row.ordering_physician"
                  >{{
                    scope.row.ordering_physician
                      ? scope.row.ordering_physician.name.includes("Dr")
                        ? scope.row.ordering_physician.name
                        : "Dr " + scope.row.ordering_physician.name
                      : "--"
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="Collected On"
              min-width="150"
              prop="collection_date"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.collection_date" class="d-flex">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(
                        scope.row.collection_date,
                        "MM-DD-yyyy"
                      )
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="Received On"
              min-width="150"
              prop="received_date"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.received_date" class="d-flex">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(scope.row.received_date, "MM-DD-yyyy")
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Reported On"
              min-width="150"
              prop="reported_at"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.reported_at" class="d-flex">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(scope.row.reported_at, "MM-DD-yyyy")
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Status"
              min-width="140"
              sortable="custom"
              prop="status"
            >
              <template v-slot="scope">
                <div class="column-status">
                  <el-dropdown
                    class="status-dropdown"
                    @command="
                      (command) =>
                        changeStatus(command, scope.row, scope.$index)
                    "
                    trigger="click"
                    v-if="hasPermission('cases', 'update_status')"
                  >
                    <span
                      class="el-dropdown-link"
                      v-if="scope.row.status && scope.row.status == 'COMPLETE'"
                    >
                      <el-tag :type="getStatusType(scope.row.status)">
                        FINALIZED
                      </el-tag>
                    </span>
                    <span class="el-dropdown-link" v-else>
                      <el-tag :type="getStatusType(scope.row.status)">{{
                        scope.row.status.split("_").join(" ")
                      }}</el-tag>
                    </span>
                    <template #dropdown>
                      <el-dropdown-menu class="status-dropdown-menu">
                        <el-dropdown-item
                          command="ACTIVE"
                          :disabled="scope.row.status === 'ACTIVE'"
                          >ACTIVE</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="TEST_REPORTS"
                          :disabled="scope.row.status === 'TEST_REPORTS'"
                          >PROCESSING</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="COMPLETE"
                          :disabled="scope.row.status === 'COMPLETE'"
                          >FINALIZED</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>

                  <el-tag
                    v-else-if="
                      getAuthenticatedUser.user_type === 'HOSPITAL_PHYSICIAN'
                    "
                    :type="getStatusType(scope.row.status)"
                    >{{
                      scope.row.status === "COMPLETE"
                        ? scope.row.status
                        : "PROCESSING"
                    }}</el-tag
                  >

                  <el-tag v-else :type="getStatusType(scope.row.status)">{{
                    scope.row.status.split("_").join(" ")
                  }}</el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="COVID STATUS"
              prop="covid_status"
              sortable="custom"
              min-width="140"
              v-if="hasCovidCaseType"
            >
              <template v-slot="scope">
                <div class="column-status">
                  <el-dropdown
                    v-if="
                      hasCovid(scope.row) &&
                      scope.row.covid_status &&
                      hasPermission('cases', 'update_covid_status')
                    "
                    class="status-dropdown"
                    @command="
                      (command) =>
                        changeCovidStatus(
                          command,
                          scope.row._id,
                          scope.$index,
                          scope.row.covid_status
                        )
                    "
                    trigger="click"
                  >
                    <span class="el-dropdown-link">
                      <el-tag
                        v-if="scope.row.covid_status != 'RESULT_AWAITED'"
                        :type="getCovidStatusType(scope.row.covid_status)"
                      >
                        {{ scope.row.covid_status }}
                      </el-tag>
                      <p v-else>Result Awaited</p>
                    </span>
                    <template #dropdown>
                      <el-dropdown-menu class="status-dropdown-menu">
                        <el-dropdown-item command="POSITIVE"
                          >POSITIVE</el-dropdown-item
                        >
                        <el-dropdown-item command="NEGATIVE"
                          >NEGATIVE</el-dropdown-item
                        >
                        <el-dropdown-item command="INCONCLUSIVE"
                          >INCONCLUSIVE</el-dropdown-item
                        >
                        <el-dropdown-item command="RESULT_AWAITED"
                          >Result Awaited</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>

                  <span
                    v-else-if="hasCovid(scope.row) && scope.row.covid_status"
                  >
                    <el-tag
                      v-if="
                        scope.row.covid_status &&
                        scope.row.covid_status != 'RESULT_AWAITED'
                      "
                      :type="getCovidStatusType(scope.row.covid_status)"
                    >
                      {{ scope.row.covid_status }}
                    </el-tag>
                    <p v-else>Result Awaited</p>
                  </span>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="billing_status"
              label="BILLING STATUS"
              min-width="150"
            >
              <template #default="scope">
                <div class="column-status">
                  <span
                    class="el-dropdown-link"
                    v-if="scope.row.billing_status"
                  >
                    <el-tag :type="getStatusType(scope.row.billing_status)">
                      {{ scope.row.billing_status }}
                    </el-tag>
                  </span>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="action"
              label="Actions"
              width="100"
              fixed="right"
            >
              <template v-slot="scope">
                <ul class="listings__action-buttons">
                  <li @click="goToCaseView(scope.row._id)">
                    <el-button class="view-button" title="View Case">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>

                  <li>
                    <el-button
                      class="reports-button"
                      @click="onViewReports(scope.row)"
                      title="Test Reports"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/pdf-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/pdf-icon-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination">
          <el-pagination
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[10, 25, 50, 100]"
            layout="prev, pager, next, jumper, sizes, total"
            :total="getAllBillingCases.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <div class="default-modal">
      <el-dialog
        top="5vh"
        v-model="dialogVisible"
        :width="isLabUser ? '90%' : '90%'"
        :before-close="closeTestReportsDialog"
      >
        <div class="dialog-header">
          <span class="header-part"> Test Reports </span>
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="closeTestReportsDialog"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
          /></el-button>
        </div>
        <TestReport
          :caseIdProp="selectedCaseId"
          :openPopup="true"
          :displayUploading="true"
        />
      </el-dialog>
    </div>
    <ExportCases
      v-if="exportReportsDialogVisisble"
      v-on:close="exportReportsDialogVisisble = false"
      :selected_dob="date_of_birth"
      :selected_case_type="caseType"
      :selected_hospital="hospital"
      :selected_physician="physician"
      :selected_string="search_string"
      :search_case_status="selectedStatuses"
    >
    </ExportCases>
    <ResonForStatusChange
      v-if="takeStatusChangeReasonDialog"
      v-on:close="takeStatusChangeReasonDialog = false"
      v-on:reasonSubmit="unsetCaseCompleteStatus"
      :width="40"
      :title="takeStatusChangeReasonDialogTitle"
    ></ResonForStatusChange>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { defineAsyncComponent } from "vue";
import caseConstants from "@/config/constants/caseConstants";
import { casesSearchOptions } from "@/config/constants/searchConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";
const ResonForStatusChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
const ExportCases = defineAsyncComponent(() =>
  import("@/components/billingCases/ExportBillingCases")
);
const TestReport = defineAsyncComponent(() =>
  import("@/components/cases/ViewTestReport")
);
import FilterHelper from "@/mixins/FilterHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
export default {
  name: "",
  components: {
    ResonForStatusChange,
    ExportCases,
    TestReport,
  },
  mixins: [UserPermissionsHelper, AppHelper, FilterHelper, caseDataHelper],
  props: {
    selectedStatuses: {
      default: [],
    },
  },
  data() {
    return {
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      dialogVisible: false,
      exportReportsDialogVisisble: false,
      takeStatusChangeReasonDialog: false,
      takeStatusChangeReasonDialogTitle: "",
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      page: 1,
      pageSize: 25,
      loading: false,
      search_string: "",
      orderBy: "updated_at",
      orderType: "DESC",
      date_of_birth: "",
      hospital: "",
      caseType: "",
      physician: "",
      searchBy: "",
      patientDOB: "",
      // searchByKey: ["PatientName", "accession_id", "EMR"],
      searchOptions: casesSearchOptions,
      caseTypes: caseConstants.CASE_TYPES_DATA,
      unsetCompleteStatusChangeCase: "",
      toStatus: "",
      selectedCaseId: null,
      hospitalsData: {},
      physiciansData: {},
      hospitalsLoading: false,
      physiciansLoading: false,
    };
  },
  computed: {
    getCovidStatusType() {
      return (statusVal) => {
        const status = statusVal;
        if (status == "POSITIVE") {
          return "danger";
        } else if (status == "NEGATIVE") {
          return "success";
        } else if (status == "INCONCLUSIVE") {
          return "info";
        } else {
          return "";
        }
      };
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "default";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else if (status == "SENT") {
          return "default";
        } else {
          return "";
        }
      };
    },
    ...mapGetters("billingCases", ["getAllBillingCases"]),
    ...mapGetters("cases", ["getUpdateCaseStatus", "getUpdateCaseCovidStatus"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
    // isSearchByInput() {
    //   return this.searchByKey.indexOf(this.searchBy) != -1 ? true : false;
    // },
    hasCovidCaseType() {
      if (
        this.searchBy == "case_types" &&
        (this.caseType == "COVID" || this.caseType == "COVID_FLU")
      ) {
        return true;
      }
      if (
        this.$route.query.selectedSearchBy == "case_types" &&
        (this.$route.query.selectedCase == "COVID" ||
          this.$route.query.selectedCase == "COVID_FLU")
      ) {
        return true;
      }
      return false;
    },
  },
  async mounted() {
    await this.setQueryParamsData();
    await this.fetchAllBillings();
  },
  methods: {
    async changeCovidStatus(command, id, index, prevStatus) {
      try {
        if (command == prevStatus) {
          return;
        }
        let params = {
          status: command,
          id: id,
        };
        await this.$store.dispatch("cases/changeCaseCovidStatus", params, {
          root: true,
        });
        if (
          this.getUpdateCaseCovidStatus &&
          this.getUpdateCaseCovidStatus.success
        ) {
          this.$notify({
            type: "success",
            title: "Success",
            message: this.getUpdateCaseCovidStatus.message,
          });
          this.getAllBillingCases.data[index].covid_status = command;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async unsetCaseCompleteStatus(reason) {
      try {
        let params = {
          id: this.unsetCompleteStatusChangeCase,
          status: this.toStatus,
          reason,
        };

        await this.updateStatus(params, this.caseIndex);
      } catch (error) {
        console.log(error);
      }
    },

    hasCovid(caseData) {
      return (
        caseData.case_types.indexOf("COVID") > -1 ||
        caseData.case_types.indexOf("COVID_FLU") > -1
      );
    },
    billingCasesExport() {
      this.exportReportsDialogVisisble = true;
    },
    async fetchAllPhysicians() {
      try {
        this.physiciansLoading = true;
        await this.$store.dispatch("physicians/fetchAllPhysicians", {
          get_all: true,
        });
        this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
        this.physiciansLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAllHospitals() {
      try {
        this.hospitalsLoading = true;
        await this.$store.dispatch("hospitals/fetchAllHospitals", {
          get_all: true,
        });
        this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
        this.hospitalsLoading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async changeStatus(command, caseData, index) {
      try {
        if (command == caseData.status) {
          return;
        }
        let params = {
          status: command,
          id: caseData._id,
        };

        if (caseData.status == "COMPLETE") {
          this.unsetCompleteStatusChangeCase = caseData._id;
          this.toStatus = command;
          this.caseIndex = index;
          this.askReasonOnUnsetCompletedStatus(caseData.status);
        } else {
          await this.updateStatus(params, index);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async updateStatus(params, index) {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/changeCaseStatus", params, {
          root: true,
        });
        this.loading = false;
        if (this.getUpdateCaseStatus && this.getUpdateCaseStatus.success) {
          this.$notify({
            type: "success",
            title: "Success",
            message: this.getUpdateCaseStatus.message,
          });
          this.getAllBillingCases.data[index].status = params.status;
          this.selectedCaseForBilling = null;
          this.patientSSN = "";
          this.patientRelationship = "";
          this.showBillingDetailsForm = false;
        }
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    async askReasonOnUnsetCompletedStatus(inputData) {
      if (inputData === "COMPLETE") {
        inputData = "Finalized";
      } else if (inputData === "TEST_REPORTS") {
        inputData = "Processing";
      }
      this.takeStatusChangeReasonDialog = true;
      this.takeStatusChangeReasonDialogTitle =
        "Reason for moving from" +
        " " +
        inputData +
        " " +
        "to" +
        " " +
        (this.toStatus === "TEST_REPORTS"
          ? "Processing"
          : this.toStatus
              .split("_")
              .map((e) => this.captilize(e))
              .join(" "));
    },
    clearInputSearch() {
      if (
        this.hospital ||
        this.physician ||
        this.date_of_birth ||
        this.caseType
      ) {
        this.hospital = "";
        this.physician = "";
        this.date_of_birth = "";
        this.caseType = "";
        this.isSearchByInput = "";
        this.page = 1;
        this.fetchAllBillings(1);
      }
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedPage: params.page,
        selectedCase: params.case_type,
        selectedHospital: params.hospital,
        selectedDateOfBirth: params.date_of_birth,
        selectedPhysician: params.ordering_physician,
        selectedString: params.search_string,
        selectedPageSize: params.limit,
        selectedOrderBy: params.order_by,
        selectedOrderType: params.order_type,
        selectedTestReportsOpen: this.$route.query.selectedTestReportsOpen,
        selectedCaseId: this.$route.query.selectedCaseId,
        selected_panel: this.$route.query.selected_panel,
        selectedSearchBy: this.searchBy || undefined,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    async closeTestReportsDialog() {
      let query = {
        selectedTestReportsOpen: undefined,
        selectedCaseId: undefined,
        selected_panel: undefined,
        selectedCase: this.$route.query.selectedCase,
        selectedPage: this.$route.query.selectedPage,
        selectedPageSize: this.$route.query.selectedPageSize,
        selectedHospital: this.$route.query.selectedHospital,
        selectedPhysician: this.$route.query.selectedPhysician,
        selectedStatus: this.$route.query.selectedStatus,
        selectedString: this.$route.query.selectedString,
      };
      this.$router.replace({ query });
      this.dialogVisible = false;
    },
    setQueryParamsData() {
      this.page = this.$route.query.selectedPage
        ? parseInt(this.$route.query.selectedPage)
        : 1;
      this.pageSize = this.$route.query.selectedPageSize
        ? parseInt(this.$route.query.selectedPageSize)
        : 25;
      if (this.$route.query.selectedString) {
        this.search_string = this.$route.query.selectedString;
      }
      if (this.$route.query.selectedCase) {
        this.caseType = this.$route.query.selectedCase;
      }
      if (this.$route.query.selectedTestReportsOpen) {
        this.dialogVisible =
          this.$route.query.selectedTestReportsOpen === "true" ? true : false;
      }
      if (this.$route.query.selectedCaseId) {
        this.selectedCaseId = this.$route.query.selectedCaseId;
      }
      if (this.$route.query.selectedSearchBy) {
        this.searchBy = this.$route.query.selectedSearchBy;
      }
      if (this.$route.query.selectedPhysician) {
        this.fetchAllPhysicians();
        this.physician = this.$route.query.selectedPhysician;
      }
      if (this.$route.query.selectedHospital) {
        this.fetchAllHospitals();
        this.hospital = this.$route.query.selectedHospital;
      }
      if (this.$route.query.selectedDateOfBirth) {
        this.date_of_birth = this.$route.query.selectedDateOfBirth;
      }
      if (this.$route.query.selectedOrderBy) {
        this.orderBy = this.$route.query.selectedOrderBy;
      }
      if (this.$route.query.selectedOrderType) {
        this.orderType = this.$route.query.selectedOrderType;
      }
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
        billing_status: "SENT",
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.date_of_birth) {
        const date_of_birth = moment(this.date_of_birth).format("YYYY-MM-DD");

        params.date_of_birth = date_of_birth;
      }
      if (this.hospital) {
        params.hospital = this.hospital;
      }
      if (this.caseType) {
        params.case_type = this.caseType;
      }
      if (this.physician) {
        params.ordering_physician = this.physician;
      }
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      params.status = this.selectedStatuses;
      return params;
    },
    getAutoCompleteBillings() {
      setTimeout(() => {
        this.page = 1;
        this.fetchAllBillings();
      }, 600);
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "updated_at";
        this.orderType = "DESC";
      }
      this.fetchAllBillings();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllBillings();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchAllBillings();
    },
    async fetchAllBillings() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch("billingCases/fetchAllBillingCases", params);
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    goToCaseView(caseId) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: caseId },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    onViewReports(testId) {
      this.selectedCaseId = testId._id;
      this.dialogVisible = true;
      let query = {
        selectedCaseId: this.selectedCaseId,
        selectedTestReportsOpen: this.dialogVisible,
      };
      this.updateQueryParam(this.$route.name, query);
    },

    addNewBillingCase() {
      this.$router.push({
        name: "AddBillingCase",
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
  },
};
</script>

<style lang="scss">
.image-fluid {
  width: 100%;
}
</style>
